//hooks
import { useEffect } from 'react';
import { useObservable }  from 'thrive-observable-react';

//services
import { CS } from '../service/Chat.Service';

//components
import ViewContainerMapper from '../components/ContainerMap';
import ChatMenu from './ChatMenu';

//interfaces
import { ChatState } from '../interfaces';

//utility
import { setupViewportListener } from '../utility/viewPort';
import { CAS } from '../service/ChatConfig.Service';



export function ChatContainer () {
    const currentChatState = useObservable<ChatState>(CAS.chatState);
    const isInPeopleSearch = useObservable(CAS.isInPeopleSearch);
    const isInActiveConversation = useObservable(CAS.isInActiveConversation);
    const isInSmallViewport = useObservable(CAS.isInSmallViewport);
    const brandingColors = useObservable(CAS.brandingColours)
    const chatIsLoaded = useObservable(CS.initialChatLoaded)
    
    const shouldShowChatMenu = 
        isInSmallViewport
        ?   (!isInPeopleSearch && !isInActiveConversation)
        :   true;

    const shouldShowChatFunctionality = 
        isInSmallViewport
        ?   !shouldShowChatMenu
        :   true;

      useEffect(() => {
        document.body.style.setProperty(
          "--chatBgColor",
          `${brandingColors.bgColor}`
        );

        document.body.style.setProperty(
          "--chatFontColor",
          `${brandingColors.fontColor}`
        );
       }, [brandingColors])

    useEffect(() => {
        const cleanup = setupViewportListener(CAS);

        //cleanup stops memoryleak
        return cleanup;
    }, []);

    useEffect(() => {
        CS.getInitialChats();

        return () => {
            CS.cleanUp();
        }
    }, []);

    useEffect(() => {
        if(chatIsLoaded) {
            CS.init();
        };
    }, [chatIsLoaded])

    useObservable(CS.me);

    return (
        <section id='chat-container'>
            {shouldShowChatMenu && 
                <ChatMenu />
            }
            
            {shouldShowChatFunctionality && 
                <section id='chat-main-window'>
                    <ViewContainerMapper 
                        chatState={currentChatState} 
                    />
                </section> 
            }
        </section>
    );
};


